import React, { useState, useEffect } from 'react';import api from '../../services/api';
import { useParams } from 'react-router-dom';
import {
  Container,
  Box,
  Avatar,
  Typography,
  Paper,
  Stack,
  Button,
  Chip,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
  SMART_COLORS as COLORS,
  smartCardSx as cardSx,
} from '../../theme/smartStableTheme';

const apiUrl = process.env.REACT_APP_API_URL;

const UserDetails = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { userId } = useParams();
  const [user, setUser] = useState(null);

  useEffect(() => {
    api
      .get(`${apiUrl}/users/${userId}`)
      .then((response) => {
        setUser(response.data);
      })
      .catch((error) => {
        console.error('Failed to fetch user details:', error);
      });
  }, [userId]);

  return (
    <Box className="smart-page-container" sx={{ bgcolor: COLORS.page, minHeight: '100vh', maxWidth: 'var(--app-page-max)', mx: 'auto' }}>
      <Container maxWidth="md" disableGutters>
        {user ? (
          <Paper elevation={0} sx={{ ...cardSx, p: { xs: 2, md: 3 } }}>
            <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" alignItems={{ xs: 'stretch', md: 'center' }} gap={2}>
              <Stack direction="row" spacing={2} alignItems="center">
              <Avatar
                sx={{
                  bgcolor: COLORS.goldSoft,
                  color: COLORS.gold,
                  width: 100,
                  height: 100,
                  fontSize: 40,
                  fontWeight: 900,
                }}
              >
                {user.first_name?.charAt(0)}
                {user.last_name?.charAt(0)}
              </Avatar>
              <Box>
              <Typography variant="h4">
                {user.first_name} {user.last_name}
              </Typography>
              <Chip label={user.role_name || user.role_name_ar || t('user')} sx={{ mt: 1, bgcolor: COLORS.goldSoft, fontWeight: 900 }} />
              </Box>
              </Stack>
              <Stack direction="row" spacing={1}>
                <Button startIcon={<ArrowBackIcon />} onClick={() => navigate('/user-list')} sx={{ color: COLORS.text, fontWeight: 900 }}>
                  {t('back') || 'Back'}
                </Button>
                <Button startIcon={<EditIcon />} variant="contained" onClick={() => navigate(`/useredit/${userId}`)} sx={{ bgcolor: COLORS.gold, '&:hover': { bgcolor: COLORS.goldHover }, fontWeight: 900 }}>
                  {t('edit') || 'Edit'}
                </Button>
              </Stack>
            </Stack>
            <Stack spacing={1.5} sx={{ mt: 3 }}>
              <Info label={t('email')} value={
                <a
                  href={`mailto:${user.email}`}
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  {user.email}
                </a>
              } />
              <Info label={t('phone')} value={user.phone} />
              <Info label={t('address')} value={user.address} />
            </Stack>
          </Paper>
        ) : (
          <Typography variant="body1">{t('loading')}</Typography>
        )}
      </Container>
    </Box>
  );
};

function Info({ label, value }) {
  return (
    <Box sx={{ p: 1.5, border: `1px solid ${COLORS.line}`, bgcolor: COLORS.cardSoft }}>
      <Typography variant="caption" sx={{ color: COLORS.gold, fontWeight: 900 }}>{label}</Typography>
      <Typography sx={{ color: COLORS.text, fontWeight: 700 }}>{value || '-'}</Typography>
    </Box>
  );
}

export default UserDetails;
